import classNames from 'classnames'
import React from 'react'
import s from './price-item.scss'
import {PriceItemProps, PriceItemSize} from './index'

export const PriceItem: React.FC<PriceItemProps> = ({
  hook,
  label,
  price,
  size = PriceItemSize.small,
}: PriceItemProps) => {
  if (!price) {
    return null
  }

  return (
    <div className={classNames(s.container, getClassName(size))} role="text" data-hook={hook}>
      <span>{label}</span>
      <span>{price}</span>
    </div>
  )
}

const getClassName = (size: PriceItemSize) => {
  switch (size) {
    case PriceItemSize.extraBig:
      return s.extraBig
    case PriceItemSize.big:
      return s.big
    case PriceItemSize.medium:
      return s.medium
    case PriceItemSize.small:
    default:
      return s.small
  }
}
